// extracted by mini-css-extract-plugin
module.exports = {"InputError":"InputError_InputError__2XXMN","wrapper":"InputError_wrapper__2XsAJ","error":"InputError_error__2TN6R"};